<template>
  <div>
    <multiselect
      :value="selectedCohorts"
      :options="cohortList"
      :multiple="true"
      label="name"
      @select="addCohort"
      @remove="removeCohort"
    />
  </div>
</template>
<script>
import Multiselect from "vue-multiselect"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { Multiselect },
  props: ["value", "skipCohortID"],
  data() {
    return {
      selectedCohorts: [],
      cohortList: [],
    }
  },
  watch: {
    cohortList() {
      if (this.cohortList && this.value) {
        Object.keys(this.value).forEach(cohortID => {
          this.cohortList.forEach(obj => {
            if (obj.id === cohortID) {
              this.pushSelectedCohort(obj)
            }
          })
        })
      } else {
        this.selectedCohorts = []
      }
    },
    value() {
      if (this.cohortList && this.value) {
        Object.keys(this.value).forEach(cohortID => {
          this.cohortList.forEach(obj => {
            if (obj.id === cohortID) {
              this.pushSelectedCohort(obj)
            }
          })
        })
      } else {
        this.selectedCohorts = []
      }
    },
  },
  async mounted() {
    await this.fetchCohorts()
  },
  methods: {
    pushSelectedCohort(obj) {
      const index = this.selectedCohorts.findIndex(o => o.id === obj.id)
      if (index === -1) {
        this.selectedCohorts.push(obj)
      }
    },
    emitSelection() {
      const cohortIDList = {}
      this.selectedCohorts.forEach(cobj => {
        cohortIDList[cobj.id] = cobj
      })
      this.$emit("input", cohortIDList)
    },
    removeCohort(delCohort) {
      this.selectedCohorts = this.selectedCohorts.filter(
        obj => obj.id !== delCohort.id
      )
      this.emitSelection()
    },
    addCohort(obj) {
      this.selectedCohorts.push(obj)
      this.emitSelection()
    },
    async fetchCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.cohortList = res.data.items.filter(
          cohort => !this.skipCohortID || cohort.id !== this.skipCohortID
        )
      })
    },
  },
}
</script>

<style lang="scss" scoped>
multiselect {
  width: 90%;
  padding: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
  background: transparent;
  background-color: #fff;
  font-size: 16px;
}
</style>
